import { createAction, props } from '@ngrx/store';
import {
  DeleteDependencies,
  LoggedUser,
  PtPermissions,
  SessionNotification,
  TemplateDocumentType,
  UiNotification,
  UiPropagatedNotification,
} from '@pt/pt-models';
import {
  JobStatus,
  LegalEntity,
  OtpUpdateRequest,
  SecretGenerateResponse,
  StorageInfo,
  WorkspaceItemType,
} from '@primatoo-ms-organization';
import { QueryParamsHandling } from '@angular/router';
import { Organization } from 'it/primatoo/openapi/api/org/schemas/organization/Organization';
import { User } from 'it/primatoo/openapi/api/org/schemas/user/User';

import { ConnectAsUserRequest } from 'it/primatoo/openapi/api/adm/schemas/user/ConnectAsUserRequest';
import { SubmitDownloadRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/SubmitDownloadRequest';
import { SubmitDownloadResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/SubmitDownloadResponse';
import { PrimatooModule } from 'it/primatoo/openapi/api/org/schemas/common/PrimatooModule';
import { UpdateOrganizationRequest } from 'it/primatoo/openapi/api/org/schemas/organization/UpdateOrganizationRequest';

export const setLoginModulesResponse = createAction(
  '[PtCore] Login Modules Response',
  props<{
    loginModules: PrimatooModule[];
  }>()
);

export const loadLoginModules = createAction('[PtCore] Load Login Modules');
export const testChangePermission = createAction(
  '[PtCore] TEST change permission',
  props<{
    permission: {
      activeModules: Array<PrimatooModule>;
      activePermissions: PtPermissions[];
    };
  }>()
);
export const updateOrganizationCss = createAction(
  '[PtCore] Update Organization Css',
  props<{ css: string }>()
);
export const updateOrganizationCssSuccess = createAction(
  '[PtCore] Update Organization Css succeeded',
  props<{ response: UpdateOrganizationRequest }>()
);
export const updateOrganizationCssFail = createAction(
  '[PtCore] Update Organization Css failed'
);
export const setResolutionScaled = createAction(
  '[PtCore] set resolution scaled',
  props<{ resolutionScaled: boolean }>()
);
export const updateLoginResponse = createAction(
  '[PtCore] update login response',
  props<{ user: User }>()
);
export const setPendingSystemLoginTo = createAction(
  '[PtCore] Set pending System login to',
  props<{ pendingSystemLogin: boolean }>()
);
export const logoutAndClearData = createAction(
  '[PtCore] Logout and clear data',
  props<{
    route: string[];
    domain: string;
    queryParams?: Record<string, unknown>;
  }>()
);
export const logoutAndClearDataForInactivityTime = createAction(
  '[PtCore] Logout and clear data for inactivity time',
  props<{ route: string[]; domain: string; userId: number; url: string }>()
);
export const cleanData = createAction('[PtCore] Clear data');
export const changeLock = createAction(
  '[PtCore] Change Lock',
  props<{ lock: boolean }>()
);
export const navigateTo = createAction(
  '[PtCore] Navigate to',
  props<{
    route: string[];
    queryParams?: Record<string, unknown>;
    onBlankPage?: boolean;
    external?: boolean;
  }>()
);
export const navigateBack = createAction(
  '[PtCore] Navigate back',
  props<{ hop: number; queryParams?: Record<string, unknown> }>()
);
export const getLegalEntity = createAction('[PtCore] Get legal entity');
export const getLegalEntitySuccess = createAction(
  '[PtCore] Get legal entity success',
  props<{ legalEntity: LegalEntity[] }>()
);
export const getLegalEntityFailed = createAction(
  '[PtCore] Get legal entity failed'
);
export const selectLegalEntity = createAction(
  '[PtCore] Select legal entity',
  props<{ selectedLegalEntity: LegalEntity[] }>()
);
export const setAnyPermission = createAction(
  '[PtCore] Set Any Permission',
  props<{ anyPermission: boolean }>()
);
export const getOrganization = createAction('[PtCore] Get organization');
export const getOrganizationSuccess = createAction(
  '[PtCore] Get organization success',
  props<{ organization: Organization }>()
);
export const getOrganizationFailed = createAction(
  '[PtCore] Get organization failed'
);
export const getOrganizationStorageInfo = createAction(
  '[PtCore] Get organization storage info'
);
export const getOrganizationStorageInfoSuccess = createAction(
  '[PtCore] Get organization storage info success',
  props<{ storageInfo: StorageInfo }>()
);
export const getOrganizationStorageInfoFailed = createAction(
  '[PtCore] Get organization storage info failed'
);
export const loginToConsole = createAction(
  '[PtCore] Login to console',
  props<{
    username: string;
    password: string;
    otpCode: string;
    rcToken?: string;
  }>()
);
export const loginToConsoleSuccess = createAction(
  '[PtCore] Login to console success',
  props<{ loginResponse: LoggedUser }>()
);
export const login = createAction(
  '[PtCore] Login',
  props<{
    domain: string;
    username: string;
    password: string;
    otpCode: string;
    rcToken?: string;
  }>()
);
export const loginAsSystem = createAction(
  '[PtCore] Login as system',
  props<{
    domain: string;
    username: string;
    password: string;
    otpCode: string;
    rcToken?: string;
  }>()
);
export const loginAsSystemSuccess = createAction(
  '[PtCore] Login as system success',
  props<{ loginResponse: LoggedUser }>()
);
export const connectAsUser = createAction(
  '[PtCore] Connect as user',
  props<{ requestBody: ConnectAsUserRequest }>()
);
export const connectAsUserSuccess = createAction(
  '[PtCore] Connect as user success',
  props<{ loginResponse: LoggedUser }>()
);
export const connectAsUserFailed = createAction(
  '[PtCore] Connect as user failed'
);
export const loginSuccess = createAction(
  '[PtCore] Login success',
  props<{ loginResponse: LoggedUser }>()
);
export const loginFailed = createAction(
  '[PtCore] login failed',
  props<{ username: string; password: string }>()
);

export const propagateDependenciesNotification = createAction(
  '[Ptcore] propagate dependencies notification',
  props<{ notification: DeleteDependencies }>()
);
export const propagateNotification = createAction(
  '[Ptcore] propagate notification',
  props<{ notification: UiPropagatedNotification }>()
);
export const showNotification = createAction(
  '[PtCore] Show notification',
  props<{
    notification: UiNotification;
    addToSession?: boolean;
  }>()
);

export const showEditSuccess = createAction(
  '[PtCore] Show edit success notification'
);
export const showEditError = createAction(
  '[PtCore] Show edit error notification'
);
export const showOperationRunning = createAction(
  '[PtCore] Show operation running'
);
export const showOperationSuccessNotification = createAction(
  '[PtCore] Show operation success notification'
);
export const showOperationFailNotification = createAction(
  '[PtCore] Show operation fail notification'
);
export const openSessionNotifications = createAction(
  '[PtCore] Open session notifications'
);
export const closeSessionNotifications = createAction(
  '[PtCore] Close session notifications'
);
export const addSessionNotifications = createAction(
  '[PtCore] Add Session notifications',
  props<{ sessionNotification: SessionNotification }>()
);
export const removeSessionNotifications = createAction(
  '[PtCore] Remove Session notifications',
  props<{ sessionNotificationId: number }>()
);
export const removeAllSessionNotifications = createAction(
  '[PtCore] Remove All Session notifications'
);
export const documentDirectDownload = createAction(
  '[PtCore] Document Direct Download',
  props<{ docId: number; resourceType: WorkspaceItemType }>()
);
export const documentTableDownloadRequest = createAction(
  '[PtCore] Document Table Download Request',
  props<{
    request: SubmitDownloadRequest;
    templateDocumentType: TemplateDocumentType;
  }>()
);
export const documentTableMultipleDownloadRequest = createAction(
  '[PtCore] Document Table Multiple Download Request',
  props<{
    request: SubmitDownloadRequest;
    templateDocumentType: TemplateDocumentType;
  }>()
);
export const documentTableSingleDownloadRequest = createAction(
  '[PtCore] Document Table Single Download Request',
  props<{
    request: SubmitDownloadRequest;
    templateDocumentType: TemplateDocumentType;
  }>()
);
export const documentTableDownloadRequestSuccess = createAction(
  '[PtCore] Document Table Download Request SUCCESS',
  props<{
    response: SubmitDownloadResponse;
    templateDocumentType: TemplateDocumentType;
  }>()
);
export const documentTableDownloadRequestFailed = createAction(
  '[PtCore] Document Table Download Request FAILED',
  props<{
    request: SubmitDownloadRequest;
    templateDocumentType: TemplateDocumentType;
  }>()
);
export const getDownloadStatus = createAction(
  '[PtCore] Download status',
  props<{ downloadIds: string[] }>()
);
export const getDownloadStatusSuccess = createAction(
  '[PtCore] Download status success',
  props<{ download: JobStatus[] }>()
);
export const getDownloadStatusFailed = createAction(
  '[PtCore] Download status failed',
  props<{ downloadIds: string[] }>()
);
export const updateDownloadSessionNotifications = createAction(
  '[PtCore] update Session notifications',
  props<{ sessionNotifications: SessionNotification[] }>()
);
export const generateTwoFactorAuthentication = createAction(
  '[PtCore] Generate Two factor authentication',
  props<{ secretGenerated: SecretGenerateResponse }>()
);
export const resetTwoFactorAuthentication = createAction(
  '[PtCore] Reset Two factor authentication',
  props<{
    user?: User;
  }>()
);

export const resetTwoFactorAuthenticationConfirmed = createAction(
  '[PtCore] Reset Two factor authentication confirmed'
);

export const notificationTwoFactorAuthentication = createAction(
  '[PtCore] Notification Two factor authentication'
);
export const twoFactorAuthenticationConfirmed = createAction(
  '[PtCore] Confirmed Two factor authentication',
  props<{
    request?: OtpUpdateRequest
  }>()
);

export const userTwoFactorAuthenticationConfirmed = createAction(
  '[PtCore] User Confirmed Two factor authentication',
  props<{
    user: User;
  }>()
);

export const setQueryParams = createAction(
  '[PtCore] Set queryParams',
  props<{
    queryParams: Record<string, unknown>;
    handling?: QueryParamsHandling;
  }>()
);
